// extracted by mini-css-extract-plugin
export var actionButton = "_xd-2";
export var card = "_xd-0";
export var disambiguationList = "_xd-3";
export var errorCard = "_xd-4";
export var row = "_xd-1";